import React from 'react'

export function NotFound() {
  return <p>We’re sorry, we couldn’t find what you’re looking for.</p>
}
